import { useTranslation } from 'react-i18next';
import { formatter } from '@repo/shared';
import type { ColumnDef } from '@tanstack/react-table';

import type { FilesQueryResult } from '@/api/generated';
import { ColumnHeader } from '@/components/blocks/data-table/column-header';

export const columns: Array<ColumnDef<FilesQueryResult[number]>> = [
  {
    accessorKey: 'name',
    header: ({ column }) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const { t } = useTranslation();
      return (
        <ColumnHeader
          column={column}
          title={t('datasets.expansion.name')}
        />
      );
    },
  },
  {
    accessorKey: 'contentType',
    header: ({ column }) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const { t } = useTranslation();
      return (
        <ColumnHeader
          column={column}
          title={t('datasets.expansion.contentType')}
        />
      );
    },
  },
  {
    accessorKey: 'createdAt',
    header: ({ column }) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const { t } = useTranslation();
      return (
        <ColumnHeader
          column={column}
          title={t('datasets.expansion.createdAt')}
        />
      );
    },
    cell: ({ row }) =>
      formatter.date.dateTime(new Date(row.original.createdAt as string)),
  },
];
